/**
 * Plan Medical Carrier — field-level effects.
 *
 * Migrated from: plan/plan-medical-carrier-base.coffee
 *
 * Old validators → new effects:
 *   CopyCarrierInfo → CopyCarrierInfo
 *
 * Skipped:
 *   handle(dfd) init logic — no runtime init needed
 */
import { copyRelatedFields } from "@neu/libui";

// ─── CopyCarrierInfo ───────────────────────────────────────────────────────
// Old: DSLFx.Validators.CopyCarrierInfo
// Trigger field: carrier_id
// Fetches carrier record and copies pcn, bin, phone, fax into form fields.
export const CopyCarrierInfo = copyRelatedFields("carrier", {
	pcn: "pcn",
	bin: "bin",
	phone: "carrier_phone",
	fax: "carrier_fax",
});
